import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import { icon } from './ui';
export default class ForumDirectory extends Component {
  tags = [];
  loading = true;
  oninit(v) {
    super.oninit(v);
    this.load();
  }
  async load() {
    try {
      const result = await app.store.find('tags', {
        include: 'parent,lastPostedDiscussion'
      });
      this.tags = Array.isArray(result) ? result : [];
    } catch {
      this.tags = [];
    }
    this.loading = false;
    m.redraw();
  }
  view() {
    if (this.loading) return m("section", {
      className: "NtForumDirectory is-loading"
    }, "\u0141adowanie dzia\u0142\xF3w forum\u2026");
    const roots = this.tags.filter(t => !t.parent?.());
    return m("section", {
      className: "NtForumDirectory"
    }, m("header", null, m("small", null, "NOVA COMMUNITY"), m("p", null, "Wybierz dzia\u0142, sprawd\u017A najnowsze tematy albo rozpocznij now\u0105 dyskusj\u0119.")), m("div", null, roots.map(tag => {
      const children = this.tags.filter(x => x.parent?.()?.id?.() === tag.id());
      return m("article", {
        style: {
          '--tag-color': tag.color?.() || '#d7a83b'
        }
      }, m("div", {
        className: "NtForumCategory-head"
      }, m("span", null, icon(tag.icon?.() || 'fas fa-folder-open')), m("div", null, m(Link, {
        href: `/t/${encodeURIComponent(tag.slug())}`
      }, tag.name()), m("p", null, tag.description?.() || 'Dyskusje społeczności NovaTruck & RP')), m("strong", null, tag.discussionCount?.() ?? 0, m("small", null, "temat\xF3w"))), children.length ? m("div", {
        className: "NtForumSubforums"
      }, children.map(child => m(Link, {
        href: `/t/${encodeURIComponent(child.slug())}`
      }, m("span", null, icon(child.icon?.() || 'far fa-folder')), m("div", null, m("strong", null, child.name()), m("small", null, child.description?.() || 'Przejdź do subforum')), m("em", null, child.discussionCount?.() ?? 0)))) : null);
    })));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/ForumDirectory', ForumDirectory);